import React, { PropsWithChildren, useCallback, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CoreAdaptersProvider, CoreAdapters, CoreLocale } from '@liefersoft/pos-ui-core'
import internalApiInstance from '../../redux/axios/internalApi/instance'
import { logger } from '../../logger/logger'
import { getAppEnvironment } from '../../helper'
import { getGlobalStore } from '../../store/globalStore'
import { setAppAfterLogout } from '../../redux/action/system'
import { disconnectSocketThunk } from '../../redux/thunk/socket'
import { setLogoutWithStorageThunk } from '../../redux/thunk/registration/auth/withStorage'

const appEnvironment = getAppEnvironment()

const AdaptersProvider = ({ children }: PropsWithChildren) => {
	const navigate = useNavigate()
	const location = useLocation()
	const { i18n } = useTranslation()

	const router = useMemo<CoreAdapters['router']>(() => ({
		push: path => navigate(path),
		prefetch: () => {
		},
		currentPathname: location.pathname,
		currentSearch: location.search
	}), [navigate, location.pathname, location.search])

	const onLogout = useCallback(() => {
		const store = getGlobalStore()
		if (!store.dispatch) return

		store.dispatch(setAppAfterLogout(true))
		store.dispatch(disconnectSocketThunk())
		store.dispatch(setLogoutWithStorageThunk())
	}, [])

	const adapters = useMemo<CoreAdapters>(() => ({
		appId: 'POS',
		appEnvironment,
		locale: i18n.language as CoreLocale,
		internalApi: internalApiInstance,
		router,
		logger,
		onLogout
	}), [i18n.language, router, onLogout])

	return (
		<CoreAdaptersProvider adapters={adapters}>
			{children}
		</CoreAdaptersProvider>
	)
}

AdaptersProvider.displayName = 'AdaptersProvider'
export default AdaptersProvider
